export const APP_COOKIES_KEY = 'wwwApp.cookiesAllowed';
export const APP_JWT_TOKEN = 'wwwApp.token';
export const APP_TOKEN_EXPIRED_AT = 'wwwApp.tokenExpiredAt';
export const APP_ACCOUNT_ORDERS = 'account.events';
